import {Component, ReactNode} from 'react';
import {Btn} from './Shared';

interface Props {children: ReactNode}
interface State {failed: boolean}

export class WorkspaceErrorBoundary extends Component<Props, State> {
  state: State = {failed: false};

  static getDerivedStateFromError(): State { return {failed: true}; }

  render() {
    if (this.state.failed) return <div className="page-error" role="alert" data-testid="workspace-render-error">
      <h2>Something interrupted this page</h2>
      <p className="section-subtitle" data-testid="workspace-render-error-message">Reload the workspace to reconnect. No browser data has been cleared.</p>
      <Btn data-testid="workspace-render-retry" onClick={() => window.location.reload()}>Reload workspace</Btn>
    </div>;
    return this.props.children;
  }
}